import { render, staticRenderFns } from "./SupportPopup.vue?vue&type=template&id=335e1aa0"
import script from "./SupportPopup.vue?vue&type=script&lang=js"
export * from "./SupportPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports